import { jsx as _jsx } from "react/jsx-runtime";
import { createModalStore } from '#pplx/frontend/aether/modals/internal/createModalStore.js';
import { ModalStoreContext } from '#pplx/frontend/aether/modals/internal/ModalStoreContext.js';
import { safeRandomUUID } from '#pplx/frontend/common/safeRandomUUID.js';
import React, { memo, useRef } from 'react';
export const ModalStoreProvider = memo(function ModalStoreProvider({ children }) {
    const storeRef = useRef(null);
    if (storeRef.current === null) {
        storeRef.current = createModalStore({
            generateId: safeRandomUUID,
        });
    }
    return (_jsx(ModalStoreContext.Provider, { value: storeRef.current, children: children }));
});
//# sourceMappingURL=ModalStoreProvider.js.map